import T_str from "./string-valid";
import T_date from "./date-valid";
export const t_str = T_str;
export const tStr = T_str;
export const t_date = T_date;
export const tDate = T_date;
